
  // document.addEventListener("DOMContentLoaded", function () {
  //   const buttons = document.querySelectorAll(".read-more-btn");

  //   buttons.forEach(button => {
  //     button.addEventListener("click", function () {
  //       const targetId = this.getAttribute("data-target");
  //       const content = document.getElementById(targetId);

  //       if (!content.classList.contains("expanded")) {
  //         // EXPAND
  //         content.style.maxHeight = content.scrollHeight + "px";
  //         content.classList.add("expanded");
  //         this.innerText = "Read Less";
  //       } else {
  //         // COLLAPSE (smooth reset trick)
  //         content.style.maxHeight = content.scrollHeight + "px";

  //         requestAnimationFrame(() => {
  //           content.style.maxHeight = "100px";
  //         });

  //         content.classList.remove("expanded");
  //         this.innerText = "Read More";
  //       }
  //     });
  //   });
  // });


  document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".read-more-btn");

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const targetId = this.getAttribute("data-target");
      const content = document.getElementById(targetId);

      // ✅ Get dynamic text from Shopify (via data attributes)
      const readMoreText = this.getAttribute("data-read-more");
      const readLessText = this.getAttribute("data-read-less");

      if (!content.classList.contains("expanded")) {
        // EXPAND
        content.style.maxHeight = content.scrollHeight + "px";
        content.classList.add("expanded");
        this.innerText = readLessText; // dynamic
      } else {
        // COLLAPSE
        content.style.maxHeight = content.scrollHeight + "px";

        requestAnimationFrame(() => {
          content.style.maxHeight = "100px";
        });

        content.classList.remove("expanded");
        this.innerText = readMoreText; // dynamic
      }
    });
  });
});